<template>
  <div
    :class="fees.length ? 'clickable-table-cell' : ''"
    @click="$tracker.openedPopup('more_fees', trackerLocation)"
  >
    <slot></slot>
    <q-menu transition-duration="100" v-if="fees.length">
      <q-separator />
      <q-markup-table flat dense square>
        <thead>
          <tr class="text-left">
            <th scope="col" class="text-left">Label</th>
            <th scope="col" class="text-left">Amount</th>
            <th scope="col" class="text-left">Frequency</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fee in fees" :key="fee.label">
            <td>{{ fee.label }}</td>
            <td>{{ formatMoney(fee.amount) }}</td>
            <td v-if="fee.frequency === 'once'">One-Time</td>
            <td v-else-if="fee.frequency === 'month'">Monthly</td>
            <td v-else-if="fee.frequency === 'year'">Annual</td>
            <td v-else>Unknown</td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-menu>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { AdditionalFee } from 'common'
import { formatMoney } from '@/utils.ts'
import type { FilterLocations } from '@/tracker.ts'

export default {
  name: 'ShowFeesPopupTableCell',
  methods: { formatMoney },
  props: {
    fees: {
      type: Array as PropType<AdditionalFee[]>,
      required: true
    },
    trackerLocation: {
      type: String as PropType<FilterLocations>,
      required: true
    }
  }
}
</script>

<style scoped></style>
